import { createReducer } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: {},
    ACourseInfo: null,
};

export const AdminCourseReducer = createReducer(initialState, (builder) => {

    builder.addCase("Admin_AddCourseRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("Admin_AddCourseSuccess", (state, action) => {
        state.loading = false;
        state.ACourseInfo = action.payload;
        state.error = {};
    })

    builder.addCase('Admin_AddCourseFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })

    // Update Course
    builder.addCase("Admin_UpdateCourseRequest", (state, action) => {
        state.loading = true
    });

    builder.addCase("Admin_UpdateCourseSuccess", (state, action) => {
        state.loading = false;
        state.ACourseInfo = action.payload;
        state.error = {};
    })

    builder.addCase('Admin_UpdateCourseFailure', (state, action) => {
        state.loading = false;
        state.error = action.payload;
    })
})